import * as React from "react";

import { cs } from "@Common/react/chain-services";
import { UseState }                   from "@Common/react/use-state";

import { ContentSectionFieldCreator } from "./contentSectionFieldCreator";
import { CustomizationTile }          from "./customizationTile";

export const Content = ({idOrder, contentData, domRef, formattingModal, setUnsavedChanges, companyPrefs}) => cs(
    ({}) =>
        <CustomizationTile
            domRef={domRef}
            header="Content"
            formattingModal={formattingModal}
            xdQaName="Content"
        >
            <ContentSectionFieldCreator
                idOrder={idOrder}
                data={contentData}
                setUnsavedChanges={setUnsavedChanges}
                companyPrefs={companyPrefs}
            />
        </CustomizationTile>
);